import {
	downloadFraudTracking,
	setFraudPage,
} from 'feature/fraudTracking/fraudTrackingSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import Button from 'styles/button/Button';
import Pagination from 'styles/pagination/Pagination';
import Stack from 'styles/stack/Stack';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const FraudTrackingFooter = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	const { pages, page } = useSelector((store: RootState) => store.fraudTracking);

	const { selectedItems, downloadAll } = useSelector(
		(store: RootState) => store.tableSelectedItems,
	);

	const handleChangePage = (_: React.ChangeEvent<unknown>, value: number) => {
		dispatch(setFraudPage(value));
	};

	return (
		<Stack
			direction={'row'}
			position={'relative'}
			sx={{ my: 4.25 }}
			alignItems={'center'}
			justifyContent={'space-between'}
		>
			<Stack
				direction={'row'}
				flexGrow={1}
				justifyContent={'flex-start'}
				alignItems={'center'}
			>
				{pages > 1 && (
					<Pagination page={page} count={pages} onChange={handleChangePage} />
				)}
			</Stack>
			<Stack
				direction={'row'}
				position={'absolute'}
				right={0}
				sx={{ gap: '10px' }}
			>
				<Button
					type="button"
					variant="contained"
					disabled={selectedItems.length > 0 || downloadAll ? false : true}
					fullWidth={false}
					onClick={() => dispatch(downloadFraudTracking({ type: 'XLSX' }))}
				>
					{tClientLabels('view-fraud-tracking.exportButton.XLSX')}
				</Button>
				{/* <Button
					type="button"
					variant="contained"
					disabled={selectedItems.length > 0 || downloadAll ? false : true}
					fullWidth={false}
					onClick={() => dispatch(downloadFraudTracking({ type: 'PDF' }))}
				>
					{tClientLabels('view-fraud-tracking.exportButton.PDF')}
				</Button> */}
			</Stack>
		</Stack>
	);
};

export default FraudTrackingFooter;
